export default "__VITE_ASSET__DEmC3Byl__"